import { render, staticRenderFns } from "./ItemsCards.vue?vue&type=template&id=7baa3938&"
import script from "./ItemsCards.vue?vue&type=script&lang=js&"
export * from "./ItemsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports